module.exports = __webpack_public_path__ + "static/media/Q_5.af6665a2.png";